var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrangeStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 84,
    viewBox: "0 0 79 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0154 35.2531C17.0154 35.2531 27.9539 33.1258 35.2462 20.6656C42.5385 8.2055 43.1462 0 43.1462 0C43.1462 0 49.2231 25.2242 62.2885 31.6062C75.3538 37.6844 79 37.6844 79 37.6844C79 37.6844 59.25 47.1054 52.5653 59.8694C45.8807 72.9374 43.7538 83.8779 43.7538 83.8779C43.7538 83.8779 35.55 55.3109 27.0423 49.5367C18.8384 43.7624 0 38.596 0 38.596L17.0154 35.2531Z",
    fill: "#FF6E40"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeStar);
export default __webpack_public_path__ + "static/media/orangeStar.c36201b9f327eb3ec42536a5c41f06b8.svg";
export { ForwardRef as ReactComponent };